import Echo from 'laravel-echo';
import Pusher from 'pusher-js';

window.Pusher = Pusher;

let _echo = null;

/**
 * Returns a lazily-created Echo instance.
 * Safe to call only after the user is authenticated (token in localStorage).
 * Subsequent calls return the same cached instance.
 */
export function getEcho() {
  if (_echo) return _echo;

  if (!process.env.VUE_APP_REVERB_APP_KEY) {
    console.warn('[echo] VUE_APP_REVERB_APP_KEY is not set — realtime notifications disabled.');
    return null;
  }

  try {
    _echo = new Echo({
      broadcaster: 'reverb',
      key: process.env.VUE_APP_REVERB_APP_KEY,
      wsHost: process.env.VUE_APP_REVERB_HOST,
      wsPort: process.env.VUE_APP_REVERB_PORT,
      wssPort: process.env.VUE_APP_REVERB_PORT,
      forceTLS: (process.env.VUE_APP_REVERB_SCHEME ?? 'https') === 'https',
      enabledTransports: ['ws', 'wss'],
      authEndpoint: `${process.env.VUE_APP_AUTHDOMAIN}/api/broadcasting/auth`,
      auth: {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('jwt')}`,
        },
      },
    });
  } catch (err) {
    console.error('Failed to initialize Echo:', err);
    return null;
  }

  return _echo;
}

/**
 * Disconnect and destroy the Echo instance (call on logout).
 */
export function destroyEcho() {
  if (_echo) {
    _echo.disconnect();
    _echo = null;
  }
}
